import authReducer from './authReducer'
import projectReducer from './projectReducer'

import { combineReducers } from 'redux'
import { firestoreReducer } from 'redux-firestore'
import { firebaseReducer } from 'react-redux-firebase'
import newsReducer from './newsReducer'

const rootReducer = combineReducers({
    auth: authReducer,
    firestore: firestoreReducer,
    firebase: firebaseReducer,
    
    news: newsReducer,
    projects: projectReducer

})

export default rootReducer